<template>
  <div>
    <v-tooltip bottom v-if="mx_calDavLinkIsEnabled">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-1" v-bind="attrs" v-on="on" icon @click="openCalDavLink">
          <v-icon>mdi-calendar-multiple</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('myDuty.caldav.tooltip') }}</span>
    </v-tooltip>
    <v-dialog v-model="calDavLinkDialog" fullscreen hide-overlay>
      <v-card>
        <v-toolbar color="primary">
          <v-btn icon @click="calDavLinkDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="dialog-title pl-0">{{ $t('myDuty.caldav.tooltip') }}</v-toolbar-title>
        </v-toolbar>
        <iframe :src="calDavIframeSrc"></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import usersApi from '@/api/usersApi';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import { mapState } from 'vuex';
import config from '@/common/config';

export default {
  name: 'DutyListHeader',
  mixins: [dutyMixin],
  data() {
    return {
      calDavLinkDialog: false,
      calDavIframeSrc: 'about:blank',
    };
  },
  computed: {
    ...mapState({
      stage: (state) => state.configs.stage,
      customerRelations: (state) => state.profile.customerRelations,
    }),
    tenant() {
      return this.customerRelations.tenant;
    },
  },
  methods: {
    getCookieValue() {
      const cName = 'cockpitToken';
      const regex = new RegExp(`(^| )${cName}=([^;]+)`);
      const match = document.cookie.match(regex);
      return match ? match[2] : '';
    },
    cockpitUrl(stage) {
      switch (stage) {
        case 'dev':
          return config.VUE_APP_COCKPIT_URL_DEV;
        case 'alpha':
        case 'test':
          return config.VUE_APP_COCKPIT_URL_ALPHA;
        case 'beta':
          return config.VUE_APP_COCKPIT_URL_BETA;
        case 'prod':
          return config.VUE_APP_COCKPIT_URL_PROD;
        default:
          return config.VUE_APP_COCKPIT_URL_DEV;
      }
    },
    async openCalDavLink() {
      let cookieValue = this.getCookieValue();
      let accessToken = cookieValue ? cookieValue : await this.getAccessToken();
      if (accessToken) {
        const cockpitUrl = this.cockpitUrl(this.stage);
        const separator = cockpitUrl.charAt(cockpitUrl.length - 1) == '/' ? '' : '/';
        this.calDavIframeSrc = cockpitUrl + separator + 'profiles/?ical&token=' + accessToken + '&mandant=' + this.tenant;
        this.calDavLinkDialog = true;
      }
    },
    async getAccessToken() {
      let response = await usersApi.getCockpitAccessToken();
      let cockpitAccessToken = response?.data?.cockpitAccessToken ? response?.data?.cockpitAccessToken : '';
      return cockpitAccessToken;
    },
  },
};
</script>

<style scoped>
iframe {
  position: absolute;
  width: 100%;
  height: calc(100% - 64px);
  border: 0;
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 960px) {
  iframe {
    height: calc(100% - 56px);
  }
}

.dialog-title {
  font-size: 1.1em;
}
</style>
